/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Delivery_HintInputs */

const vi_einvoice_delivery_hint = /** @type {(inputs: Einvoice_Delivery_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn phát hành được khi đơn đã giao thành công.`)
};

/**

* @param {Einvoice_Delivery_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_delivery_hint = /** @type {((inputs?: Einvoice_Delivery_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Delivery_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_delivery_hint(inputs)
});